import React, { useEffect, useMemo, useRef, useState } from 'react';
import { OtpInput } from '../OtpInput/OtpInput';
import { ActivityIndicator, Animated, Dimensions, FlatList, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View, } from 'react-native';
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
import LottieView from 'lottie-react-native';
import { Button } from '../../button/Button';
import { Header } from '../../header/Header';
import { isMobile, isMobileView } from '../../stack/utils';
import { AppBottomNav } from '../../appBottomNav/AppBottomNav';
import { addCommasToNumber, getLenderIcon } from '../utils';
import UnpledgeSearch from '../UnpledgeSearch';
import { HeaderDefaultBase } from '../../header/HeaderDefault.Base';
import TooltipComp from '../TooltipComp';
import Divider from '../../divider/Divider';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import NeedHelpDC from '../NeedHelpDC';
const UnpledgePortfolio = ({ bankData, tempCreditResponse, profileAction, stepperData, triggerAction, backAction, applyAction, modalState, continuePress, userName, height, creditLimit, phoneNumber, error, sanctionedAmount, totalOutstanding, addBankAction, counter, showOtpModalUnpledge, lenderName, needHelp, extraOutstandingBufferBajaj, extraOutstandingBufferDsp, otpErrorModal, otpErrorMessage, contactUsDetails, isFromJupiter, editButtonClickedAction, showMaxLimitError, closeMaxLimitErrorModal, }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    let eligibleFilters = [];
    const inputRef = useRef(null);
    const [SlideInLeft, setSlideIn] = useState(new Animated.Value(0));
    const [showModal, setShowModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(otpErrorModal);
    const [infoBox, setInfoBox] = useState(false);
    const [boxNumber, setBoxNumber] = useState(-1);
    const [currentActuallimit, setCurrentActualLimit] = useState(0);
    const [currentActualFund, setCurrentActualFund] = useState(0);
    const [isLimitFull, setIsLimitFull] = useState(false);
    const [currentIcinCode, setCurrentIcinCode] = useState('');
    const [maxCurrentUnpledgeFund, setMaxCurrentUnpledgeFund] = useState(0);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [showCamsFetchLoader, setShowCamsFetchLoader] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const [isErrorState, setIsErrorState] = useState(false);
    const [keyboardHeight, setKeyboardHeight] = useState(0);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [creditValue, setCreditValue] = useState(0);
    const [seconds, setSeconds] = useState(20);
    const [isRunning, setIsRunning] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [filtersSections, setFiltersSection] = useState([]);
    const [list, setList] = useState({});
    const [rupeeLottie, setRupeeLottie] = useState('');
    const [successLottie, setSuccessLottie] = useState('');
    const [flatData, setFlatData] = useState([]);
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(360);
    const [isDismissable, setDismissable] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [mutualSum, setMutualSum] = useState(0);
    const [mutualLimit, setMutualLimit] = useState(0);
    const [pledgedArray, setPledgedArray] = useState([]);
    const [filterName, setFilterName] = useState('EQUITY');
    const [showCreditLimit, setShowCreditLimit] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const fontFamilyMapping = theme.fontFamily;
    let bgColor = theme.colors[ColorTokens.Primary_100];
    const handleStartStop = () => {
        setIsRunning((prevIsRunning) => !prevIsRunning);
    };
    const handleReset = () => {
        setSeconds(20);
        setIsRunning(true);
    };
    const mobHeight = Dimensions.get('window').height;
    useEffect(() => {
        setShowOtpModal(showOtpModalUnpledge);
        setButtonLoading(false);
    }, [showOtpModalUnpledge, counter]);
    useEffect(() => {
        setShowErrorModal(otpErrorModal);
        setButtonLoading(false);
    }, [otpErrorModal, counter]);
    useEffect(() => {
        setIsErrorState(error);
    }, [error, userName]);
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        if (error) {
            setIsErrorState(true);
        }
    }, [error]);
    const setInitialData = () => {
        bankData.map((item) => {
            if (eligibleFilters.includes(item.assetSubType)) {
                // Do nothing basically
            }
            else {
                eligibleFilters.push(item.assetSubType);
            }
        });
        setFiltersSection(eligibleFilters);
    };
    useEffect(() => {
        const handleResize = () => {
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.clientHeight;
            const newKeyboardHeight = windowHeight - documentHeight;
            setKeyboardHeight(newKeyboardHeight);
        };
        // @ts-ignore
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [setKeyboardHeight]);
    useEffect(() => {
        if (modalState) {
            if (modalState === 'error') {
                setModalState(modalState);
                setDismissable(true);
                setModalHeight(244);
            }
            if (modalState === 'success') {
                setModalState(modalState);
                setModalHeight(isMobileView() ? 260 : 240);
            }
            if (modalState === 'info') {
                setModalHeight(360);
            }
            setModalState(modalState);
        }
    }, [modalState]);
    const handlePledgeState = () => {
        setPledgedArray(pledgedArray);
    };
    const handleCloseErrorModal = async () => {
        await triggerAction(closeMaxLimitErrorModal);
    };
    const _headerChildCustom = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'space-between',
                paddingVertical: Platform.OS === "ios" ? 6 : 0,
                ...Platform.OS === 'ios' && { marginTop: 28 }
            } },
            React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(View, { nativeID: 'bt_removePledge_goBack' },
                    React.createElement(TouchableOpacity, { style: { marginRight: 4, }, onPress: () => {
                            if (!showConfirmation && backAction) {
                                triggerAction(backAction);
                            }
                            else {
                                setShowConfirmation(false);
                            }
                        } },
                        React.createElement(Icon, { name: IconTokens.BackArrowIcon, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night }))),
                React.createElement(Typography, { label: showConfirmation
                        ? 'Confirm unpledging'
                        : 'Remove pledge from MFs', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20, color: ColorTokens.Grey_Night })),
            React.createElement(View, { nativeID: 'bt_removePledge_info' },
                React.createElement(TouchableOpacity, { style: {
                        backgroundColor: '#F3F5FC',
                        display: 'flex',
                        flexDirection: 'row',
                        paddingVertical: 4,
                        paddingHorizontal: 8,
                        borderRadius: 24,
                        alignItems: 'center'
                    }, hitSlop: { top: 48, bottom: 48, left: 48, right: 48 }, onPress: () => {
                        setShowNeedHelp(true);
                    } },
                    React.createElement(Icon, { name: IconTokens.Whatsapp, size: IconSizeTokens.XL, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: {
                            marginLeft: 4
                        } },
                        React.createElement(Typography, { label: 'NEED HELP?', fontSize: FontSizeTokens.XXS, fontWeight: "500", lineHeight: 16, color: ColorTokens.Primary_100, fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(View, { style: { width: 4 } })))));
    };
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: {
                padding: 16,
                alignItems: 'center',
                flex: 1,
            } },
            successLottie && React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: 'Unpledge request raised successfully', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'RTAs may take 3-5 business days to remove pledge from your portfolio', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    marginBottom: 10,
                    paddingBottom: 12,
                    marginTop: 24
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (addBankAction) {
                            triggerAction(addBankAction);
                        }
                    } }))));
    };
    const renderWarning = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1, alignItems: 'center', flex: 1, }, activeOpacity: 1 },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: 'Max unpledge limit reached ', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    marginTop: 8,
                    backgroundColor: '#F1F3F5',
                    width: '100%',
                    padding: 16,
                    marginBottom: 24,
                    borderRadius: 8,
                } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'You cannot select more funds for un-pledging.', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    paddingBottom: 8,
                    marginBottom: 4,
                } },
                React.createElement(Button, { id: 'bt_removePledge_continueUnpledge', type: ButtonTypeTokens.LargeSoftFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, label: 'Ok, got it!', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setShowModal(false);
                        setModalState('Penny');
                        setModalHeight(332);
                        // if(profileAction){
                        //     triggerAction(profileAction)
                        // }
                    } }))));
    };
    const renderOtpErrorModalBody = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "OTP Attempts Exceeded" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: otpErrorMessage, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: () => setShowErrorModal(false), isDisabled: false }))));
    };
    const renderMaxLimitErrorModalBody = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Unpledge limit Exceeded" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: otpErrorMessage, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: handleCloseErrorModal, isDisabled: false }))));
    };
    const renderErrorContent = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1, alignItems: 'center', flex: 1, }, activeOpacity: 1 },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: 'Max unpledge limit reached ', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    marginTop: 8,
                    backgroundColor: '#F1F3F5',
                    width: '100%',
                    padding: 16,
                    marginBottom: 24,
                    borderRadius: 8,
                } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'You cannot select more funds for un-pledging.', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    paddingBottom: 8,
                    marginBottom: 4,
                } },
                React.createElement(Button, { id: 'bt_removePledge_continueUnpledge', type: ButtonTypeTokens.LargeSoftFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, label: 'Ok, got it!', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setShowModal(false);
                        setModalHeight(332);
                        // if(profileAction){
                        //     triggerAction(profileAction)
                        // }
                    } }))));
    };
    const renderInfoBox = () => {
        return (React.createElement(TouchableOpacity, { style: {
                padding: 16,
                zIndex: 1
            }, activeOpacity: 1, onPress: () => setShowToolTip(false) },
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, label: "Updated credit limit" }),
            React.createElement(View, { style: { marginTop: 24, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8, padding: 12 } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'Credit limit against portfolio', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(creditLimit))}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: { flexDirection: "row" } },
                            React.createElement(Typography, { label: 'Selected limit for unpledging', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }))),
                    React.createElement(Typography, { label: `-₹${addCommasToNumber(mutualLimit)}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: "#E4E7EC", marginTop: 16 } }),
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'Updated credit limit against\nportfolio', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(creditLimit - mutualLimit))}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: { flexDirection: "row" } },
                            React.createElement(Typography, { label: 'Max loan amount sanctioned', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                            React.createElement(View, { style: { width: 8 } }),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    setShowToolTip(true);
                                } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.LG, color: ColorTokens.Grey_Charcoal }),
                                showToolTip &&
                                    React.createElement(TooltipComp, { title: "This is the max sanctioned loan amount approved as per your loan agreement, it can be revised by doing another agreement by increasing your limit." })))),
                    React.createElement(Typography, { label: `₹${addCommasToNumber(sanctionedAmount)}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: "#E4E7EC", marginTop: 16 } }),
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Updated credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(creditLimit - mutualLimit))}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Secondary_100 }))),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Got it", fontSize: FontSizeTokens.SM, onPress: () => {
                        setIsRunning(false);
                        setShowOtpModal(false);
                        setIsErrorState(false);
                        setShowCamsFetchLoader(false);
                    } }))));
    };
    const calculateSumOfAssetPledgedValue = (assets) => {
        let sum = 0;
        for (const asset of assets) {
            sum += asset.assetPledgedValue;
        }
        return Math.floor(sum);
    };
    useEffect(() => {
        let limit = 0;
        for (const asset of bankData) {
            limit += asset.assetCurrentLimit;
        }
        //https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json
        let listObj = {
            eligibleAssetData: bankData,
            nonEligibleAssetData: [],
        };
        setInitialData();
        console.warn('LIST OBJECT IS', listObj);
        setList(listObj);
        setCreditValue(calculateSumOfAssetPledgedValue(bankData));
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    useEffect(() => {
        fetch('https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
    }, [modalState]);
    const renderEmptyState = () => {
        return (React.createElement(View, { style: [
                styles.blankContainer,
                { height: height },
            ] },
            React.createElement(View, { style: {
                    width: '100%',
                    marginHorizontal: -16,
                } },
                React.createElement(Header, { type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: 'Link bank account', onPress: () => {
                        if (backAction) {
                            triggerAction(backAction);
                        }
                    } })),
            React.createElement(View, { style: {
                    marginTop: 24,
                    alignItems: 'flex-start',
                    alignSelf: 'flex-start',
                } },
                React.createElement(Typography, { label: 'Add bank account for receiving cash', fontWeight: 'bold', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins })),
            React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                    width: '100%',
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Add bank account', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (profileAction) {
                            triggerAction(profileAction);
                        }
                    } }))));
    };
    const _bodyChild = () => {
        console.warn('RE RENDERED WITH THE NEW LIST SAGAR', selectedList);
        // @ts-ignore
        return (React.createElement(View, null,
            React.createElement(View, { style: { marginTop: 16, marginHorizontal: 16 } },
                React.createElement(Typography, { label: 'Select mutual funds', fontWeight: '600', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { height: showCreditLimit ? height - 270 : height - 228, padding: 16, paddingBottom: Platform.OS === 'ios' ? 50 : 0 } }, Object.keys(list).length !== 0 && (React.createElement(UnpledgeSearch, { data: selectedFilters, dataa: list, flatData: flatData, totalOutStanding: totalOutstanding, lenderId: lenderName, alreadyPledgedArray: pledgedArray, onLimitReached: (receivedState) => {
                    if (receivedState === "ERROR") {
                        setModalState('error');
                        setShowModal(true);
                        setModalHeight(244);
                    }
                    if (receivedState === "WARNING") {
                        setModalState("WARNING");
                        setShowModal(true);
                        setModalHeight(244);
                    }
                }, onPortfolioSelected: (value, limit, pledgedArray, selectedList) => {
                    setShowCreditLimit(true);
                    setMutualSum(value);
                    setMutualLimit(limit);
                    setPledgedArray(pledgedArray);
                    setSelectedFilters(selectedList);
                }, creditLimit: creditLimit, onFitlerSet: () => {
                    console.warn('ELIGIBLE FILTERS ARE ', eligibleFilters);
                    setShowModal(true);
                    setModalHeight(height - 50);
                    setModalState("");
                    setFilterData(bankData.filter((item) => item.assetSubType ===
                        filtersSections[0]));
                    setFilterName(filtersSections[0]);
                }, isFromEligible: true, triggerAction: triggerAction, height: height, extraOutstandingBufferBajaj: extraOutstandingBufferBajaj, extraOutstandingBufferDsp: extraOutstandingBufferDsp, onMaxMfSelected: (boxIndex, showInfoBox, CurrentActualLimit, currentPledgedValue, limitFull, currentIcinCode, maxCurrentUnpledgeFund) => {
                    setBoxNumber(boxIndex);
                    setInfoBox(showInfoBox);
                    setCurrentActualLimit(CurrentActualLimit);
                    setCurrentActualFund(currentPledgedValue);
                    setIsLimitFull(limitFull);
                    setCurrentIcinCode(currentIcinCode);
                    setMaxCurrentUnpledgeFund(maxCurrentUnpledgeFund);
                }, onApplyFilter: (pledgedArray) => {
                    setPledgedArray(pledgedArray);
                }, boxNumber: boxNumber, maxCurrentUnpledgeFund: maxCurrentUnpledgeFund, infoBox: infoBox, currentActuallimit: currentActuallimit, currentActualFund: currentActualFund, isLimitFull: isLimitFull, currentIcinCode: currentIcinCode, tempCreditResponse: tempCreditResponse })))));
    };
    const _footerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(AppBottomNav, { currentRoute: 'MANAGE_LIMIT', triggerAction: triggerAction })));
    }, []);
    const ChecklistItem = ({ item, onPress }) => {
        const [isChecked, setIsChecked] = useState(false);
        const handlePress = (item) => {
            console.warn('IN THIS ');
            setIsChecked(!isChecked);
            // handleItemPress(item.isin);
        };
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        console.warn('SEL data prior ', data);
                        const index = data.indexOf(item);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item);
                        }
                        console.warn('SEL data ', data);
                        setSelectedList(data);
                        setFilterData(bankData.filter((item) => item.assetSubType === filterName));
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        let data = selectedList;
                        console.warn('SEL data prior ', data);
                        const index = data.indexOf(item);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item);
                        }
                        console.warn('SEL data ', data);
                        setSelectedList(data);
                        setFilterData(bankData.filter((item) => item.assetSubType === filterName));
                    }, style: { width: '100%', marginLeft: 8, paddingRight: 16 } },
                    React.createElement(Typography, { label: item.assetName, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Night })))));
    };
    const applyFilter = () => {
        let filteredData = [];
        if (selectedList.length === 0) {
            let listObj = {
                eligibleAssetData: bankData,
                nonEligibleAssetData: [],
            };
            setFlatData(filteredData);
            setList(listObj);
            setFlatData(bankData);
            return;
        }
        console.warn('FINAL FILTERED LIST $$$$$$$$$$$$$$$$$$$', selectedList);
        bankData.map((item) => {
            selectedList.includes(item)
                ? filteredData.push(item)
                : null;
        });
        let listObj = {
            eligibleAssetData: filteredData,
            nonEligibleAssetData: [],
        };
        setFlatData(filteredData);
        setList(listObj);
    };
    useEffect(() => {
        console.warn('SAGAR LIST UPDATED', list);
    }, [list]);
    const filterHeader = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignContent: 'center',
                    // paddingTop: 11,
                    // paddingBottom: 11,
                    height: 60,
                } },
                React.createElement(TouchableOpacity, { style: { paddingLeft: 12 }, onPress: () => {
                        // setAllSelected(!allSelected);
                        // let selectedAllList = selectedList
                        //
                        // console.warn("ALL SELECTED VALUE", allSelected)
                        // if (allSelected) {
                        // 	const isinKeys = filterData.map(
                        // 		(item) => item.isin,
                        // 	);
                        //
                        // 	const filteredsArray =
                        // 		selectedAllList.filter(
                        // 			(value) => !isinKeys.includes(value),
                        // 		);
                        //
                        // 	setSelectedList(filteredsArray);
                        // 	return;
                        // }
                        //
                        // filterData.map((item) => {
                        // 	selectedAllList.push(item.isin);
                        // });
                        //
                        // setSelectedList(selectedAllList);
                        // //
                        // // setFilterData(
                        // //     combindedData.filter(
                        // //         (item) => item.fundType === filterName,
                        // //     ),
                        // // );
                    } },
                    React.createElement(Icon, { name: false
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                    } },
                    React.createElement(Text, { style: [styles.itemText, { width: 200 }], ellipsizeMode: 'tail', numberOfLines: 1 }, 'Select All'))),
            React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                } })));
    };
    const returnFilter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                height: Platform.OS === "ios" ? height + 5 : height - 45,
                zIndex: 1,
                flexDirection: 'column',
                flex: 1
            } },
            isMobile(getScreenType(Dimensions.get('window').width)) && React.createElement(TouchableOpacity, { onPress: () => {
                    setShowModal(false);
                }, style: { position: 'absolute', right: 0, top: 0, padding: 16, zIndex: 1 } },
                React.createElement(Icon, { name: IconTokens.Cancel, size: IconSizeTokens.XXL })),
            React.createElement(View, null,
                React.createElement(HeaderDefaultBase, { title: 'Filter' })),
            React.createElement(View, { style: !height
                    ? {
                        flexDirection: 'row',
                        borderTopWidth: 1,
                        borderColor: '#E4E7EC',
                        flex: 1,
                    }
                    : {
                        flexDirection: 'row',
                        borderTopWidth: 1,
                        borderColor: '#E4E7EC',
                        height: Platform.OS === 'web' ? height - 150 : height - 140
                    } },
                React.createElement(FlatList, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                    }, scrollEnabled: false, showsVerticalScrollIndicator: false, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#E4E7EC',
                            height: 1,
                        } })), data: filtersSections, renderItem: ({ item }) => (React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                setFilterData(bankData.filter((items) => items.assetSubType === item));
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(ScrollView, { alwaysBounceVertical: false, bounces: false, showsVerticalScrollIndicator: false, alwaysBounceHorizontal: false, style: height
                        ? {
                            height: height - 156,
                            marginBottom: 180,
                            paddingHorizontal: 16,
                            width: 100,
                        }
                        : { height: 550, marginBottom: 180 } }, filterData.map((item) => {
                    return (React.createElement(View, null,
                        React.createElement(ChecklistItem, { item: item, onPress: () => {
                                console.warn('ITEM PRESSED', item);
                            } }),
                        React.createElement(View, { style: {
                                backgroundColor: '#E4E7EC',
                                height: 1,
                            } })));
                }))),
            React.createElement(View, { style: { height: 56 } }),
            React.createElement(View, { style: {
                    height: 56,
                    position: 'absolute',
                    bottom: Platform.OS !== 'ios' ? -5 : 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: Dimensions.get('window').width < 576
                        ? 'center'
                        : 'flex-end',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    shadowColor: '#000000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.9,
                    shadowRadius: 3,
                } },
                React.createElement(TouchableOpacity, { onPress: () => {
                        setSelectedList([]);
                        let listObj = {
                            eligibleAssetData: bankData,
                            nonEligibleAssetData: []
                        };
                        setFlatData(bankData);
                        setList(listObj);
                    }, style: {
                        marginRight: 18,
                        borderWidth: 1,
                        borderColor: colorMapping[ColorTokens.Primary_100],
                        backgroundColor: 'white',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Reset filter', color: ColorTokens.Primary_100, fontWeight: '700', fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        applyFilter();
                        setShowModal(false);
                    }, style: {
                        marginRight: 30,
                        backgroundColor: colorMapping[ColorTokens.Primary_100],
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Apply', color: ColorTokens.White })))));
    };
    const returnOtpModal = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16 }, activeOpacity: 1 },
            React.createElement(Typography, { label: 'Enter 6-digit OTP', fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night, lineHeight: 28, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    padding: 12,
                    display: 'flex',
                    borderRadius: 12,
                    borderWidth: 1,
                    borderColor: colorMapping[ColorTokens.Secondary_20],
                    backgroundColor: colorMapping[ColorTokens.Secondary_05],
                    flexDirection: 'row'
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        width: 40,
                        padding: 8,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 400,
                        backgroundColor: '#FFF'
                    } },
                    React.createElement(Icon, { name: IconTokens.MessageOtp, color: ColorTokens.Secondary_100 })),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'column'
                    } },
                    React.createElement(Typography, { label: 'OTP sent to', fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, lineHeight: 18, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Space, { size: SizeTypeTokens.XS }),
                    React.createElement(Typography, { label: `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, phoneNumber.length)}`, fontWeight: '500', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, null,
                React.createElement(OtpInput, { id: 'tf_removePledge_otp', numberOfDigits: 6, ref: inputRef, editable: !showCamsFetchLoader, onTextChange: async (text) => {
                        if (text.length === 6) {
                            setShowCamsFetchLoader(true);
                            setIsErrorState(false);
                            if (applyAction) {
                                await triggerAction({
                                    ...applyAction,
                                    payload: {
                                        otp: text,
                                    },
                                });
                            }
                            setShowCamsFetchLoader(false);
                        }
                        else {
                            setIsErrorState(false);
                            setShowCamsFetchLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : colorMapping[ColorTokens.Primary_100], theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8 },
                        pinCodeTextStyle: { fontSize: 15 },
                        containerStyle: { width: 300 },
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: { marginTop: 6 } }),
                showCamsFetchLoader && !isErrorState && React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                isErrorState && inputRef?.current?.clear(),
                isErrorState && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: userName }))),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: {
                        paddingTop: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: () => {
                            setShowTimer(true);
                            if (seconds === 0) {
                                //@ts-ignore
                                inputRef?.current?.clear();
                                handleReset();
                                setIsErrorState(false);
                                if (profileAction) {
                                    triggerAction({
                                        ...profileAction,
                                        payload: {
                                            pledgedArray: pledgedArray,
                                        },
                                    });
                                }
                            }
                        } },
                        React.createElement(Typography, { id: 'txt_commonScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0
                                ? ColorTokens.Primary_100
                                : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                showTimer && seconds > 0 && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Typography, { label: `You can resend in ${seconds} ${seconds === 1 ? 'sec' : 'secs'}`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Grey_Night }))))));
    };
    const handleInfoPress = () => {
        setModalState('info');
        setModalHeight(380);
        setShowOtpModal(true);
    };
    const renderConfirmationBodyChild = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    backgroundColor: '#F9FAFB',
                    paddingVertical: 10,
                    paddingHorizontal: 16,
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                } },
                React.createElement(Typography, { label: 'Lending partner', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, lineHeight: 18, fontWeight: '400' }),
                React.createElement(Icon, { name: getLenderIcon(lenderName) })),
            React.createElement(ScrollView, { style: { height: height - 200, paddingBottom: 50, backgroundColor: colorMapping[ColorTokens.Primary_05] } },
                React.createElement(View, null,
                    React.createElement(View, { style: { backgroundColor: "#FFFFFF", paddingBottom: 16 } },
                        React.createElement(View, { style: {
                                marginTop: 16,
                                marginHorizontal: 16,
                                backgroundColor: '#FFFFFF'
                            } },
                            React.createElement(Typography, { label: 'Unpledge MF details', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, fontWeight: '600' })),
                        React.createElement(View, { style: {
                                marginTop: 16,
                                borderColor: '#E4E7EC',
                                borderWidth: 1,
                                borderRadius: 8,
                                marginHorizontal: 16,
                                backgroundColor: '#FFFFFF'
                            } },
                            React.createElement(View, { style: {
                                    paddingHorizontal: 16,
                                    paddingTop: 16,
                                    // backgroundColor: '#FFFFFF'
                                } },
                                React.createElement(Typography, { label: 'Selected portfolio', fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontFamily: FontFamilyTokens.Inter })),
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    marginTop: 5,
                                    paddingHorizontal: 16,
                                    // backgroundColor: '#FFFFFF'
                                } },
                                React.createElement(Typography, { label: `₹${addCommasToNumber(mutualSum)}`, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                                React.createElement(View, { style: { marginLeft: 3, marginTop: 2 } },
                                    React.createElement(Typography, { label: `out of ₹${addCommasToNumber(creditValue)}`, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                            React.createElement(View, { style: {
                                    height: 1,
                                    backgroundColor: '#E4E7EC',
                                    width: '100%',
                                    marginTop: 12,
                                    marginBottom: 12,
                                } }),
                            React.createElement(View, { style: { paddingHorizontal: 16 } },
                                React.createElement(Typography, { label: 'Selected credit limit', fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontFamily: FontFamilyTokens.Inter })),
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    marginTop: 5,
                                    paddingHorizontal: 16,
                                } },
                                React.createElement(Typography, { label: `₹${addCommasToNumber(mutualLimit)}`, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                            React.createElement(View, { style: {
                                    height: 1,
                                    width: '100%',
                                    backgroundColor: '#E4E7EC',
                                    marginTop: 12,
                                } }),
                            React.createElement(View, { nativeID: 'txt_removePledge_edit', style: {
                                    paddingHorizontal: 16,
                                    paddingVertical: 12,
                                } },
                                React.createElement(TouchableOpacity, { onPress: () => {
                                        // setSelectedList([]);
                                        let listObj = {
                                            eligibleAssetData: bankData,
                                            nonEligibleAssetData: []
                                        };
                                        // setFlatData(bankData)
                                        // setList(listObj)
                                        setShowConfirmation(false);
                                        triggerAction(editButtonClickedAction);
                                    } },
                                    React.createElement(Typography, { label: 'Edit  >', color: ColorTokens.Primary_100, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', fontFamily: FontFamilyTokens.Inter }))))),
                    React.createElement(View, { style: { padding: 16, backgroundColor: '#FFFFFF', marginTop: 16 } },
                        React.createElement(Typography, { label: 'Updated credit limit', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, fontWeight: '600' }),
                        React.createElement(View, { style: {
                                marginTop: 16,
                                flexDirection: 'row',
                            } },
                            React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(creditLimit - mutualLimit))}`, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(TouchableOpacity, { style: { marginLeft: 6, marginTop: 4 }, onPress: handleInfoPress },
                                React.createElement(Icon, { name: IconTokens.Info, color: ColorTokens.Grey_Charcoal, size: IconSizeTokens.MD })))),
                    React.createElement(View, { style: { padding: 16, backgroundColor: "#FFFFFF", marginTop: 16 } },
                        React.createElement(Typography, { label: 'Process to remove the pledge', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, fontWeight: '600' }),
                        React.createElement(Text, { style: { marginTop: 16, flexDirection: 'row' } },
                            React.createElement(Typography, { label: 'Note: ', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontWeight: '600' }),
                            React.createElement(Typography, { label: 'Your request to remove pledge will be completed in 2-3 working days. ', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontWeight: '400' }),
                            React.createElement(Typography, { label: 'This action cannot be undone.', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontWeight: '600' })))))));
    };
    const calculateTobeUnPledgedUnits = (item) => {
        const selectedArray = tempCreditResponse.filter(asset => asset.assetCode === item.assetCode);
        //@ts-ignore
        if (Math.floor(selectedArray[0]?.assetPledgedValue) === Math.floor(item?.assetPledgedValue)) {
            return item.assetPledgedUnits;
        }
        const tobeUnPledgedUnits = item.assetPledgedValue /
            item.assetCurrentMarketPrice;
        return tobeUnPledgedUnits;
    };
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const renderConfirmation = () => {
        return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 8 : height }] },
            React.createElement(View, { style: {
                    flex: 1,
                } },
                React.createElement(View, { style: styles.header }, _headerChildCustom()),
                React.createElement(View, { style: [{ height: height - 138 }] }, renderConfirmationBodyChild()),
                !showOtpModal && React.createElement(View, { style: styles.footer },
                    React.createElement(View, { style: { padding: 16 } },
                        React.createElement(Button, { id: 'bt_removePledge_continueOtp', type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, loading: buttonLoading, width: ButtonWidthTypeToken.FULL, onPress: () => {
                                pledgedArray.forEach((item) => {
                                    item.tobeUnPledgedUnits =
                                        calculateTobeUnPledgedUnits(item);
                                });
                                setButtonLoading(true);
                                setModalState('OTP');
                                setModalHeight(Platform.OS !== "web" ? 350 : 300);
                                handleStartStop();
                                if (profileAction) {
                                    triggerAction({
                                        ...profileAction,
                                        payload: {
                                            pledgedArray: pledgedArray,
                                        },
                                    });
                                }
                            }, label: 'Confirm and get OTP' })))),
            showOtpModal && (React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } }, (React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => {
                    setIsRunning(false);
                    setShowOtpModal(false);
                    setIsErrorState(false);
                    setShowCamsFetchLoader(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: cardState !== "success", radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 504, routeId: 'routeId', handleKeyboard: true }, renderModalBody())))),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter }),
            (showErrorModal && !showOtpModal) && (React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 264 : 240, width: '100%', closeFunction: () => setShowErrorModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, renderOtpErrorModalBody()))),
            (showMaxLimitError && !showOtpModal) && (React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 280 : 256, width: '100%', closeFunction: handleCloseErrorModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, renderMaxLimitErrorModalBody())))));
    };
    const renderMainBody = () => {
        return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 14 : height }] },
            React.createElement(View, { style: {
                    flex: 1,
                } },
                React.createElement(View, { style: styles.header }, _headerChildCustom()),
                React.createElement(View, { style: [{ height: height - 138 }] }, _bodyChild()),
                React.createElement(View, { style: styles.footer },
                    React.createElement(View, { style: { padding: 16 } },
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Selected fund value', color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: '₹' + addCommasToNumber(mutualSum), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: ColorTokens.Grey_Night })),
                        showCreditLimit && React.createElement(View, { style: { marginTop: 12 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 })),
                        showCreditLimit && React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: 12,
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Updated credit limit', color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(creditLimit - mutualLimit))}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: ColorTokens.Secondary_100 })),
                        !showModal && React.createElement(View, { style: { marginTop: 12 } },
                            React.createElement(Button, { id: 'bt_removePledge_continueUnpledge', onPress: () => {
                                    setShowConfirmation(true);
                                }, label: 'Continue to un-pledge', type: pledgedArray.length === 0
                                    ? ButtonTypeTokens.LargeOutline
                                    : ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM }))))),
            showModal && (React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, renderMainModalBody()))),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
    };
    const renderMainModalBody = () => {
        switch (cardState) {
            case 'OTP': {
                return returnOtpModal();
                break;
            }
            case 'WARNING': {
                return renderWarning();
                break;
            }
            case 'error': {
                return renderErrorContent();
                break;
            }
            default: {
                return returnFilter();
            }
        }
    };
    const renderModalBody = () => {
        switch (cardState) {
            case 'OTP': {
                return returnOtpModal();
                break;
            }
            case 'WARNING': {
                return renderWarning();
                break;
            }
            case 'info': {
                return renderInfoBox();
                break;
            }
            case 'success': {
                return renderVerificationSuccess();
                break;
            }
            case 'error': {
                return renderErrorContent();
                break;
            }
            default: {
                return renderInfoBox();
            }
        }
    };
    return showConfirmation
        ? renderConfirmation()
        : renderMainBody();
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        width: '100%',
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#667085',
        color: 'white',
        padding: 16,
        borderRadius: 5,
        width: 272,
        bottom: '100%',
        left: '50%',
        transform: [{ translateX: -150 }],
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        justifyContent: 'center',
        borderColor: '#F2F4F7',
        borderTopWidth: 1,
        paddingHorizontal: -16,
        paddingVertical: 8,
        backgroundColor: 'white',
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#e4e7ec',
        paddingBottom: 61,
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    itemContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 2,
        maxWidth: Dimensions.get('window').width < 576
            ? '85%'
            : '90%',
        marginLeft: 8,
    },
    itemText: {
        fontSize: 16,
        marginLeft: 3,
    },
    checkedItemText: {
        textDecorationLine: 'line-through',
    },
    header: {
        paddingHorizontal: 16,
        marginTop: Platform.OS === "ios" ? 18 : 0,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
});
export default UnpledgePortfolio;
